import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import AppButton from "../design-system/components/AppButton";
import AppCallout from "../design-system/components/AppCallout";
import { isDemoMode, stopDemoMode } from "../demoMode";

export default function DemoModeBanner() {
  const { t } = useTranslation();
  const [active, setActive] = useState(isDemoMode());
  const [writeBlocked, setWriteBlocked] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const update = () => setActive(isDemoMode());
    const showReadOnlyMessage = () => setWriteBlocked(true);
    window.addEventListener("storage", update);
    window.addEventListener("timetab:demo-mode-changed", update);
    window.addEventListener("timetab:demo-write-blocked", showReadOnlyMessage);
    return () => {
      window.removeEventListener("storage", update);
      window.removeEventListener("timetab:demo-mode-changed", update);
      window.removeEventListener("timetab:demo-write-blocked", showReadOnlyMessage);
    };
  }, []);

  if (!active) return null;

  const backToWelcome = () => {
    stopDemoMode();
    navigate("/welcome?choose=1");
  };

  return (
    <AppCallout
      variant="info"
      title={t("demo_mode.title")}
      description={t(writeBlocked ? "demo_mode.read_only" : "demo_mode.description")}
      action={
        <AppButton variant="outlined" size="sm" onClick={backToWelcome}>
          {t("demo_mode.back")}
        </AppButton>
      }
    />
  );
}
